var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBayrak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 100,
    viewBox: "0 0 53 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7998 0C2.87155 0 1.98131 0.368749 1.32493 1.02513C0.668555 1.6815 0.299805 2.57174 0.299805 3.5V93L4 99C4 99.5 7.2998 93 7.2998 93V47H50.2998C51.228 47 52.1183 46.6312 52.7747 45.9749C53.4311 45.3185 53.7998 44.4283 53.7998 43.5V3.5C53.7998 2.57174 53.4311 1.6815 52.7747 1.02513C52.1183 0.368749 51.228 0 50.2998 0H4.2998C4.21505 0.000641563 4.13034 0.00397658 4.0458 0.01C3.96392 0.00414328 3.88189 0.000808363 3.7998 0ZM17.5998 7H27.3998V14.43H37.1998V7H46.7998V14.43H37.1998V24.229H46.7998V34.029H37.1998V40H27.3998V34.03H17.5998V40H7.7998V34.03H17.5998V24.229H7.7998V14.429H17.5998V7ZM17.5998 14.43V24.229H27.3998V14.429L17.5998 14.43ZM27.3998 24.229V34.03L37.1998 34.029V24.229H27.3998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBayrak);
export default __webpack_public_path__ + "static/media/bayrak.be6a2680d95b6a73fff7c325c7a881ab.svg";
export { ForwardRef as ReactComponent };